module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Bowl-2faeda9dca6961f09ce901eae3cd7372.svg";